/**
 * Application Constants and Business Configuration
 */

// Business WhatsApp Contact Configuration
export const WHATSAPP_NUMBER = import.meta.env?.VITE_WHATSAPP_NUMBER || '919945902862';
export const WHATSAPP_DEFAULT_MSG = "Hi, I'm interested in ISPL's automation consulting services.";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_DEFAULT_MSG)}`;
